import { render, staticRenderFns } from "./AddTeacherModal.vue?vue&type=template&id=6d1deb71&scoped=true&"
import script from "./AddTeacherModal.vue?vue&type=script&lang=js&"
export * from "./AddTeacherModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1deb71",
  null
  
)

export default component.exports